var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.1667 3V7.5C13.1667 8.12132 13.689 8.625 14.3333 8.625H19M13.3668 3H7.33333C6.04467 3 5 4.00736 5 5.25V18.75C5 19.9926 6.04467 21 7.33333 21H16.6667C17.9553 21 19 19.9926 19 18.75V8.43198C19 7.83524 18.7542 7.26295 18.3166 6.84099L15.0168 3.65901C14.5792 3.23705 13.9857 3 13.3668 3Z",
    stroke: "#4F4D55",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.579ca86f8d9485dc66d3bea8cfcfddd8.svg";
export { ForwardRef as ReactComponent };